module.exports = __webpack_public_path__ + "static/media/my-profile.a6288abd.svg";